import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";

const ReferralCoupons = ({ userId }) => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferrals = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        const q = query(
          collection(db, "referrals"), 
          where("referrerId", "==", userId)
        );
        const snap = await getDocs(q);
        const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setReferrals(list);
      } catch (error) {
        console.error("Error fetching referrals:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, [userId]);

  if (loading) {
    return (
      <div className="bg-white border rounded p-4 shadow">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>
    );
  }

  if (!referrals.length) {
    return null;
  }

  return (
    <div className="bg-white border rounded p-4 shadow">
      <h4 className="font-bold text-green-700 mb-3 flex items-center">
        🎁 Your Referral Coupons ({referrals.length}/5)
      </h4>
      <div className="space-y-2">
        {referrals.map((referral) => (
          <div key={referral.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
            <div className="flex-1">
              <div className="font-medium text-green-600 text-sm">
                {referral.couponCode}
              </div>
              <div className="text-xs text-gray-500">
                Referred: {referral.referredUserEmail || "Unknown"}
              </div>
              <div className="text-xs text-gray-500">
                Status: {referral.status || "pending"}
              </div>
            </div>
            <div className="text-right">
              <div className="text-sm font-semibold text-green-700">₹150 OFF</div>
              <div className="text-xs text-gray-500">
                {referral.status === "completed" ? "✅ Completed" : "⏳ Pending"}
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-3">
        💡 You can earn up to 5 referral coupons. Each coupon gives ₹150 off your next subscription!
      </p>
    </div>
  );
};

export default ReferralCoupons; 